// test1091
(1091 && 0);
